import { serverTime } from '../../../core/time/business-time';
import { Injectable } from '@angular/core';
import { Step4CompletionState } from '../domain/registration-model';

/** Non-secret browser-session evidence. Unknown operations never expire into retryable ones. */
@Injectable({ providedIn: 'root' })
export class RegistrationReceiptStorage {
  private readonly key = 'smft.member.step4Completion';
  read(): Step4CompletionState | null {
    const raw = sessionStorage.getItem(this.key);
    if (!raw) return null;
    const value: unknown = JSON.parse(raw);
    if (!value || typeof value !== 'object' || Array.isArray(value)) throw new Error('Invalid registration receipt');
    const r = value as Record<string, unknown>;
    if (!['new_membership', 'temporary_registration', 'main_registration'].includes(String(r['type'])) ||
      !['pending', 'unknown', 'success', 'failed'].includes(String(r['status'])) ||
      typeof r['studioId'] !== 'string' || !/^[1-9]\d*$/.test(r['studioId']) ||
      typeof r['savedAt'] !== 'number' || !Number.isFinite(r['savedAt'])) {
      throw new Error('Invalid registration receipt');
    }
    if (r['clockBasis'] === 'server-jst-v1' && ['success', 'failed'].includes(String(r['status'])) && serverTime.now() - r['savedAt'] > 30 * 60 * 1000) return null;
    return {
      flowId: typeof r['flowId'] === 'string' ? r['flowId'] : undefined,
      operationId: typeof r['operationId'] === 'string' ? r['operationId'] : undefined,
      type: String(r['type']), studioId: r['studioId'], status: r['status'] as Step4CompletionState['status'],
      clockBasis: r['clockBasis'] === 'server-jst-v1' ? 'server-jst-v1' : undefined, savedAt: r['savedAt'], gmoCreateError: r['gmoCreateError'] === true, emailSent: r['emailSent'] === true,
      imageWarning: r['imageWarning'] === true, lang: typeof r['lang'] === 'string' ? r['lang'] : 'ja',
      memberId: (typeof r['memberId'] === 'number' || typeof r['memberId'] === 'string') && Number.isSafeInteger(Number(r['memberId'])) && Number(r['memberId']) > 0 ? Number(r['memberId']) : undefined,
      paymentMethod: r['paymentMethod'] === '0' || r['paymentMethod'] === '1' ? r['paymentMethod'] : undefined,
      btPaymentEnabled: r['btPaymentEnabled'] === 1 ? 1 : 0,
    };
  }
  write(value: Step4CompletionState): void {
    const { flowId, operationId, type, studioId, status, savedAt, clockBasis, gmoCreateError, emailSent, imageWarning, lang, memberId, paymentMethod, btPaymentEnabled } = value;
    sessionStorage.setItem(this.key, JSON.stringify({ flowId, operationId, type, studioId, status, savedAt, clockBasis, gmoCreateError, emailSent, imageWarning, lang, memberId, paymentMethod, btPaymentEnabled }));
  }
  clear(): void { sessionStorage.removeItem(this.key); }
}
